export function getFirebaseErrorMessage(errorCode) {
  let errorMessage = '';

  switch (errorCode) {
    case 'auth/invalid-email':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      errorMessage = 'Sorry, you have entered an incorrect email or password.';
      break;
    case 'auth/user-disabled':
      errorMessage = 'Sorry, your account has been disabled.';
      break;
    case 'auth/email-already-in-use':
      errorMessage = 'Sorry, there was an issue signing in.';
      break;
    case 'auth/weak-password':
      errorMessage = 'Sorry, but you need a stronger password.';
      break;
    case 'auth/too-many-requests':
      errorMessage = 'Too many attempts. Please wait a moment and try again.';
      break;
    case 'auth/network-request-failed':
      errorMessage = 'Network error. Please check your connection and try again.';
      break;
    case 'auth/play-services':
      errorMessage = 'You do not have Google Play Services available';
      break;
    case 'auth/apple':
      errorMessage = 'There was an issue signing in with your Apple account';
      break;
    case 'auth/user-token-expired':
      errorMessage = 'Your session expired. Please sign in again.';
      break;
    default:
      errorMessage = 'There was a problem with authentication. Please try again.';
  }

  return errorMessage;
}

/**
 * Maps web login/signup gate failures (reCAPTCHA execute/verify) to a support-friendly message.
 * Auth errors should use getFirebaseErrorMessage instead.
 */
export function getRecaptchaErrorMessage(error) {
  const code = (error && error.code) || '';
  const message = (error && error.message) || '';

  if (!code && /grecaptcha|recaptcha/i.test(message)) {
    return 'Security check could not run. Refresh the page, allow Google scripts, or disable ad blockers, then try again.';
  }

  if (!code) {
    return 'Security check could not run. Please refresh the page and try again.';
  }

  // Prefer the callable/backend message when present (e.g. "Verification failed. Please try again.")
  const detail = message.replace(/^Firebase:\s*/i, '').replace(/\s*\([^)]*\)\.?\s*$/, '').trim();
  const suffix = code ? ` (${code})` : '';

  if (detail && !/^https?error/i.test(detail)) {
    return `${detail}${suffix}`;
  }

  return `Security verification failed. Please refresh and try again.${suffix}`;
}

export function testCollection(card) {
  return card;
}
